"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Ribbon_1 = require("../ribbon/src/Ribbon");
var ErrorTracking_1 = require("../cs_common/ErrorTracking");
ErrorTracking_1.default("Email_support");
ReactDOM.render(React.createElement("div", null,
    React.createElement(Ribbon_1.default, { product: selectionProduct })), document.getElementById("product-selection"));
